module.exports = __webpack_public_path__ + "img/whwdjx.3201c633.jpg";